import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Lozenge from '@atlaskit/lozenge/lozenge';

const i18n = defineMessages({
	internalTesting: {
		id: 'space-curation.internal-testing-lozenge',
		defaultMessage: 'Internal Testing',
		description:
			'Lozenge label shown on the space curation entry points and review modal, marking the feature as available for internal testing only',
	},
});

export const InternalTestingLozenge = (): React.JSX.Element => {
	const intl = useIntl();
	return <Lozenge appearance="accent-gray">{intl.formatMessage(i18n.internalTesting)}</Lozenge>;
};
